import React, { useCallback, useMemo } from "react";
import wl_logo from "../static/images/WL_LOGO.svg";
import "../sass/layout/_footer2.scss";
import "../sass/main.scss";
import useWindowDimensions from "../hooks/useWindowDimensions.js";
import instaIcon from "../static/images/icons/instagram.svg";
import linkedIcon from "../static/images/icons/linkedIn.svg";
import { useNavigate } from "react-router-dom";
import { Image } from "../components/Image.js";

export const Footer = () => {
  const { width } = useWindowDimensions();
  const navigate = useNavigate();

  const onIconClick = useCallback(() => {
    navigate("/");
    window.scrollTo(0, 0);
  }, [navigate]);


  const renderMobileView = useMemo(() => {

    if (width > 600) return;

    return <>
      <div className="section-1">
        <div className="footer-section">
          <div className="footer-section-label">Quick Links</div>
          <div className="footer-section-links">
            <a href="/">Home</a>
            <a href="/about">About Us</a>
            <a href="/contact">Enquire Now</a>
            <a href="/faq">FAQ's</a>
          </div>
        </div>

        <div style={{ textAlign: "right" }} className="footer-section">
          <div className="footer-section-label">Destinations</div>
          <div className="footer-section-links">
            <a href="/:India">India</a>
            <a href="/:Bhutan">Bhutan</a>
            <a href="/:SriLanka">Sri Lanka</a>
          </div>
        </div>

        <div className="footer-section">
          <div
            className="footer-section-label"
          >
            T&C Apply
          </div>
          <div className="footer-section-links">
            <div>Sailing Seascapes {width < 600 && <br />} PTE. LTD.</div>
            <div>TA03724</div>
          </div>

          <div className="footer-section-links">
            <a href="mailto:info@wanderluxe.sg">info@wanderluxe.sg</a>
          </div>
        </div>

        <div style={{ textAlign: "right" }} className="footer-section">
          <div className="footer-section-label">Follow Us</div>
          <div className="footer-section-links" style={{ flexDirection: "row", justifyContent: "flex-end" }}>
            <a href="https://www.instagram.com/wanderluxe_sg/profilecard/?igsh=a21ldXNvd20yZzk3">
              <Image src={instaIcon} height={25} width={25} />
            </a>
            <a href="https://www.linkedin.com/company/wanderluxe-sg/">
              <Image alt="linkedIn" src={linkedIcon} height={25} width={25} />
            </a>
          </div>
        </div>

      </div>
      <div className="section-2">
        <img alt="WanderLuxe" src={wl_logo} type="image/svg+xml" onClick={onIconClick} />
        <p>
          Customised journeys exclusively for women
        </p>
      </div>
    </>
  }, [onIconClick, width]);

  const renderDesktopView = useMemo(() => {
    if (width < 600) return;

    return (
      <>
        <div className="section-1">
          <div className="footer-section">
            <div className="footer-section-label">Quick Links</div>
            <div className="footer-section-links">
              <a href="/">Home</a>
              <a href="/about">About Us</a>
              <a href="/contact">Enquire Now</a>
              <a href="/faq">FAQ's</a>
            </div>
          </div>

          <div className="footer-section">
            <div className="footer-section-label">Destinations</div>
            <div className="footer-section-links">
              <a href="/:India">India</a>
              <a href="/:Bhutan">Bhutan</a>
              <a href="/:SriLanka">Sri Lanka</a>
            </div>
          </div>

          <div className="footer-section">
            <div className="footer-section-label">Follow Us</div>
            <div className="footer-section-links" style={{ flexDirection: "row", justifyContent: "flex-start" }}>
              <a href="https://www.instagram.com/wanderluxe_sg/profilecard/?igsh=a21ldXNvd20yZzk3">
                <Image src={instaIcon} height={25} width={25} />
              </a>
              <a href="https://www.linkedin.com/company/wanderluxe-sg/">
                <Image alt="linkedIn" src={linkedIcon} height={25} width={25} />
              </a>
            </div>
          </div>
        </div>
        <div className="section-2">
          <img alt="wanderluxe" src={wl_logo} type="image/svg+xml" onClick={onIconClick} />
          <p>
            Customised journeys exclusively for women
          </p>
        </div>

        <div className="section-3">
          <div className="footer-section">
            <div
              className="footer-section-label"
            >
              Terms and Conditions apply
            </div>
            <div className="footer-section-links">
              <div>Sailing Seascapes {width < 600 && <br />} PTE. LTD.</div>
              <div>TA03724</div>
            </div>

            <div className="footer-section-links">
              <a href="mailto:info@wanderluxe.sg">info@wanderluxe.sg</a>
            </div>
          </div>
        </div>
      </>

    )
  }, [onIconClick, width]);

  return (
    <div className="footer">
      {renderMobileView}
      {renderDesktopView}
    </div>
  );
};
